import React, { createContext, useContext } from 'react';
import { IReviewContext } from './types';

const initialValue: IReviewContext = {
  onReviewExpansion: undefined,
};
const ReviewContext = createContext<IReviewContext>(initialValue);

export const useReviewContext = () => useContext(ReviewContext);

export const ReviewContextContainer: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<IReviewContext>
>> = props => {
  return (
    <ReviewContext.Provider value={props}>
      {props.children}
    </ReviewContext.Provider>
  );
};
